import React, { useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faPowerOff,
  faUser,
  faList,
  faLayerGroup,
  faUtensils,
  faChair,
  faTabletAlt,
  faKey,
  faChartLine,
  faClock,
  faClipboardList,
  faBars,
  faXmark,
} from "@fortawesome/free-solid-svg-icons";
import { NavLink } from "react-router-dom";
import { useAuth0 } from "@auth0/auth0-react";
import "../styles/NavBar.css";
import garconLogo from "../assets/garcon_icon_notext.png";

const NAV_SECTIONS = [
  {
    label: "Genel Bakış",
    items: [
      { type: "link", to: "/admin/statistics", icon: faChartLine, label: "İstatistikler" },
      { type: "link", to: "/admin/shifts", icon: faClock, label: "Vardiyalar" },
      { type: "link", to: "/admin/audit", icon: faClipboardList, label: "Denetim Kaydı" },
    ],
  },
  {
    label: "Yönetim",
    items: [
      { type: "link", to: "/admin/users", icon: faUser, label: "Kullanıcılar" },
      { type: "link", to: "/admin/areas", icon: faTabletAlt, label: "Alanlar" },
    ],
  },
  {
    label: "Menü Yönetimi",
    items: [
      { type: "link", to: "/admin/menus", icon: faUtensils, label: "Menü Özeti" },
      { type: "link", to: "/admin/categories", icon: faLayerGroup, label: "Kategoriler" },
      { type: "link", to: "/admin/items", icon: faList, label: "Ürünler" },
    ],
  },
  {
    label: "Yerleşim",
    items: [
      { type: "link", to: "/admin/tables", icon: faChair, label: "Masalar" },
      { type: "link", to: "/admin/floors", icon: faLayerGroup, label: "Katlar" },
    ],
  },
  {
    label: "Profil",
    items: [
      { type: "link", to: "/admin/profile", icon: faKey, label: "Şifre Değiştir" },
    ],
  },
];

const NavBar = () => {
  const { isAuthenticated, loginWithRedirect, logout } = useAuth0();
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  const logoutWithRedirect = () =>
    logout({
      logoutParams: {
        returnTo: window.location.origin,
      },
    });

  return (
    <aside className={`nav-container ${isMobileMenuOpen ? "mobile-open" : ""}`}>
      <div className="admin-mobile-topbar">
        <div className="admin-mobile-brand">
          <img src={garconLogo} alt="Garcon" className="navbar-logo" />
          <div className="admin-mobile-brand-text">
            <strong>Garcon</strong>
            <span>Yönetim Paneli</span>
          </div>
        </div>
        <button
          type="button"
          className="admin-mobile-toggle"
          onClick={() => setIsMobileMenuOpen((value) => !value)}
          aria-label="Navigasyonu aç"
          aria-expanded={isMobileMenuOpen}
        >
          <FontAwesomeIcon icon={isMobileMenuOpen ? faXmark : faBars} />
        </button>
      </div>

      <div className="nav-shell-body">
        <div className="admin-navbar-brand">
          <img src={garconLogo} alt="Garcon" className="navbar-logo" />
          <div className="admin-navbar-brand-copy">
            <strong>Garcon</strong>
            <span>Yönetim Paneli</span>
          </div>
        </div>

        <div className="navbar-top admin-nav-sections">
          {NAV_SECTIONS.map((section) => (
            <section className="admin-nav-section" key={section.label}>
              <div className="admin-nav-section-label">{section.label}</div>
              <div className="admin-nav-section-items">
                {section.items.map((item) => (
                  <NavLink
                    key={item.to}
                    to={item.to}
                    title={item.label}
                    className={({ isActive }) =>
                      `admin-nav-link ${isActive ? "active" : ""}`
                    }
                    onClick={() => setIsMobileMenuOpen(false)}
                  >
                    <FontAwesomeIcon icon={item.icon} className="admin-nav-icon" />
                    <span className="admin-nav-label">{item.label}</span>
                  </NavLink>
                ))}
              </div>
            </section>
          ))}
        </div>

        <div className="navbar-bottom">
          {isAuthenticated ? (
            <button id="qsLogoutBtn" className="logout-button" onClick={logoutWithRedirect} title="Çıkış Yap">
              <FontAwesomeIcon icon={faPowerOff} className="logout-icon" />
              <span className="logout-label">Çıkış Yap</span>
            </button>
          ) : (
            <button id="qsLoginBtn" className="logout-button" onClick={() => loginWithRedirect()} title="Giriş Yap">
              <FontAwesomeIcon icon={faPowerOff} className="logout-icon" />
              <span className="logout-label">Giriş Yap</span>
            </button>
          )}
        </div>
      </div>
    </aside>
  );
};

export default NavBar;
